import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import ContentWrapper from "../../../Wrapper";
import GatewayAndPriceSubheader from "../../components/gateway-and-price-subheader";
import * as whatsappPriceActions from "../../store/actions/gateway_and_price_list_whatsapp_actions";
import WhatsappPrice2SidePanel from "../../components/whatsapp-price-2-side-panel";

const GATEWAY_AND_PRICE_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
};

export default function WhatsappPrice2List() {
  const tabName = "SMS Pricing";
  const [selectedGatewayAndPriceWithAction, setSelectedGatewayAndPriceWithAction] = useState({
    action: GATEWAY_AND_PRICE_ACTIONS.NONE,
    data: {},
  });
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [search, setSearch] = useState("");

  const dispatch = useDispatch();

  const whatsappStore = useSelector((state) => state.gatewayAndPrice.whatsapp2);

  useEffect(() => {
    dispatch(whatsappPriceActions.getListOfWhatsappPrice2Request({ limit: limit, page: pageNo, search: search }));
  }, [dispatch, limit, pageNo, search]);

  return (
    <ContentWrapper subHeader={<GatewayAndPriceSubheader tabName={tabName} >
      <Form.Control placeholder="Search country here..." style={{ width: "300px" }} value={search} onChange={e => setSearch(e.target.value)} />
    </GatewayAndPriceSubheader>}>
      {whatsappStore.loading ? (
        <ContentWithCardLoading />
      ) : whatsappStore.data.length === 0 ? (
        "No accounts"
      ) : (
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Route Name", apiKeyName: "route", fieldInputType: "INPUT" },
                { title: "Country Name", apiKeyName: "countryName", fieldInputType: "INPUT" },
                { title: "Country ISO", apiKeyName: "countryIso", fieldInputType: "INPUT" },
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Price", apiKeyName: "price", fieldInputType: "INPUT" },
                { title: "Actions", isAction: true, options: ["edit"] },
              ]}
              data={whatsappStore.data}
              limit={limit}
              pageNo={pageNo}
              setLimit={setLimit}
              setPageNo={setPageNo}
              count={whatsappStore.count}
              // actions
              handleEdit={(data) => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_AND_PRICE_ACTIONS.EDIT, data })}
            />
          </div>
          <WhatsappPrice2SidePanel
            show={selectedGatewayAndPriceWithAction.action === GATEWAY_AND_PRICE_ACTIONS.EDIT}
            gatewayAndPriceData={selectedGatewayAndPriceWithAction.data}
            loadingData={{ limit, page: pageNo }}
            handleClose={() => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_AND_PRICE_ACTIONS.NONE, data: {} })}
          />
        </div>
      )}
    </ContentWrapper>
  );
}
